export const getImageLinkWithWebPFormat = (imageLink: string) => {
  return `${imageLink}?format=webp`;
};
